import { makeApiCall } from "../makeApiCall";
import { PackageApiCall } from "./MakeAPiCall";
import { AdminService_URL, ThirdPartyService_URL } from "../Url";

export const packageTrackerActions = {
  PACKAGE_SUCCESS: "PACKAGE_SUCCESS",
  PACKAGE_ERROR: "PACKAGE_ERROR",
  PRINT_PDF_SUCCESS: "PRINT_PDF_SUCCESS",
  PRINT_PDF_ERROR: "PRINT_PDF_ERROR",
  CP_SUCCESS: "CP_SUCCESS",
  CP_FAILURE: "CP_FAILURE",
  CREATE_ZOHO_PACKAGE_SUCCESS: "CREATE_ZOHO_PACKAGE_SUCCESS",
  CREATE_ZOHO_PACKAGE_ERROR: "CREATE_ZOHO_PACKAGE_ERROR",
  UPDATE_PACKAGE_STATUS_SUCCESS: "UPDATE_PACKAGE_STATUS_SUCCESS",
  UPDATE_PACKAGE_STATUS_ERROR: "UPDATE_PACKAGE_STATUS_ERROR",
  MARK_HAND_DELIVER_SUCCESS: "MARK_HAND_DELIVER_SUCCESS",
  MARK_HAND_DELIVER_ERROR: "MARK_HAND_DELIVER_ERROR",
  CREATE_ORDER_CP_SUCCESS: "CREATE_ORDER_CP_SUCCESS",
  CREATE_ORDER_CP_ERROR: "CREATE_ORDER_CP_ERROR",
  FETCH_ZOHO_SUCCESS: "FETCH_ZOHO_SUCCESS",
  FETCH_ZOHO_ERROR: "FETCH_ZOHO_ERROR",
  GENERATE_CSV_SUCCESS: "GENERATE_CSV_SUCCESS",
  GENERATE_CSV_ERROR: "GENERATE_CSV_ERROR",
  SR_SUCCESS: "SR_SUCCESS",
  SR_FAILURE: "SR_FAILURE",
};

// Generate CSV

export function generateCSVForStickerDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.GENERATE_CSV_SUCCESS,
      payload: props,
    });
  };
}

export function generateCSVForStickerDetailsError(error) {
  return {
    type: packageTrackerActions.GENERATE_CSV_ERROR,
    payload: error,
  };
}

export function generateCSVForStickerDetailsThunk(access_token) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
  };
  const getUrl = `${AdminService_URL}/generateCSVForStickerDetails`;
  return makeApiCall(
    getUrl,
    generateCSVForStickerDetailsSuccess,
    generateCSVForStickerDetailsError,
    "GET",
    null,
    reqHeader
  );
}

// Update package status

export function updatePackageStatusSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.UPDATE_PACKAGE_STATUS_SUCCESS,
      payload: props,
    });
  };
}

export function updatePackageStatusError(error) {
  return {
    type: packageTrackerActions.UPDATE_PACKAGE_STATUS_ERROR,
    payload: error,
  };
}

export function updatePackageStatusThunk(data, access_token) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
  };
  const Url = `${AdminService_URL}/updatePackageDetails`;
  return makeApiCall(
    Url,
    updatePackageStatusSuccess,
    updatePackageStatusError,
    "POST",
    data,
    reqHeader,
    data.history
  );
}

// Fetch All Package Tracker Data

export function packageTrackerSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.PACKAGE_SUCCESS,
      payload: props,
    });
  };
}

export function packageTrackerError(error) {
  return {
    type: packageTrackerActions.PACKAGE_ERROR,
    payload: error,
  };
}

export function packageTrackerThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.accessToken,
  };
  const getUrl = `${AdminService_URL}/fetchPackageDetails?isOrderDispatched=${props.isDispatched}`;
  return PackageApiCall(
    getUrl,
    packageTrackerSuccess,
    packageTrackerError,
    "GET",
    null,
    reqHeader
  );
}

// Print PDF.

export function printPDFSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.PRINT_PDF_SUCCESS,
      payload: props,
    });
  };
}

export function printPDFError(error) {
  return {
    type: packageTrackerActions.PRINT_PDF_ERROR,
    payload: error,
  };
}

export function downloadPDFThunk(content, isCallFromPkgMgmt, accessToken) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + accessToken,
  };
  const Url = `${ThirdPartyService_URL}/generateInvoicePDF?isCallFromPkgMgmt=${isCallFromPkgMgmt}`;
  return makeApiCall(
    Url,
    printPDFSuccess,
    printPDFError,
    "POST",
    content,
    reqHeader
  );
}

// Recommend Delivery partner

export function CPRecommendSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.CP_SUCCESS,
      payload: props,
    });
  };
}

export function CPRecommendError(error) {
  return {
    type: packageTrackerActions.CP_FAILURE,
    payload: error,
  };
}

export function clickPostRecommendationThunk(props) {
  const transactionId = `Order-${props.orderId}`;
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const Url = `${ThirdPartyService_URL}/callCpRecommendationAPI?orderId=${props.orderId}&paymentType=${props.paymentType}&transactionId=${transactionId}`;
  return makeApiCall(
    Url,
    CPRecommendSuccess,
    CPRecommendError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

// Create ZOHO package

export function createZohoPackageSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.CREATE_ZOHO_PACKAGE_SUCCESS,
      payload: props,
    });
  };
}

export function createZohoPackageError(error) {
  return {
    type: packageTrackerActions.CREATE_ZOHO_PACKAGE_ERROR,
    payload: error,
  };
}

export function createZohoPackageThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const Url = `${ThirdPartyService_URL}/createZohoPackage?orderId=${props.orderId}`;
  return makeApiCall(
    Url,
    createZohoPackageSuccess,
    createZohoPackageError,
    "GET",
    null,
    reqHeader
  );
}

// Mark Package HAND DELIVER

export function markHandDeliverSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.MARK_HAND_DELIVER_SUCCESS,
      payload: props,
    });
  };
}

export function markHandDeliverError(error) {
  return {
    type: packageTrackerActions.MARK_HAND_DELIVER_ERROR,
    payload: error,
  };
}

export function handDeliveredThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const Url = `${ThirdPartyService_URL}/handDeliveredRequest?orderId=${props.orderId}&salesOrderId=${props.salesOrderId}&packageId=${props.packageId}&isNewFlow=true`;
  return makeApiCall(
    Url,
    markHandDeliverSuccess,
    markHandDeliverError,
    "POST",
    null,
    reqHeader
  );
}

// Mark Package Exprees bees or delhivery

export function CPCreateOrderSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.CREATE_ORDER_CP_SUCCESS,
      payload: props,
    });
  };
}

export function CPCreateOrderError(error) {
  return {
    type: packageTrackerActions.CREATE_ORDER_CP_ERROR,
    payload: error,
  };
}

export function CPCreateOrderThunk(reqBody, access_token) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
  };
  const Url = `${ThirdPartyService_URL}/createOrderCp`;
  return makeApiCall(
    Url,
    CPCreateOrderSuccess,
    CPCreateOrderError,
    "POST",
    reqBody,
    reqHeader
  );
}

// Fetch All Invoices from Zoho

export function fetchAllInvoicesFromZohoSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.FETCH_ZOHO_SUCCESS,
      payload: props,
    });
  };
}

export function fetchAllInvoicesFromZohoError(error) {
  return {
    type: packageTrackerActions.FETCH_ZOHO_ERROR,
    payload: error,
  };
}

export function fetchAllInvoicesFromZohoThunk(access_token) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
  };
  const getUrl = `${ThirdPartyService_URL}/fetchAllInvoicesFromZoho`;
  return makeApiCall(
    getUrl,
    fetchAllInvoicesFromZohoSuccess,
    fetchAllInvoicesFromZohoError,
    "GET",
    null,
    reqHeader
  );
}

// Recommend Delivery partner

export function SRRecommendSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: packageTrackerActions.SR_SUCCESS,
      payload: props,
    });
  };
}

export function SRRecommendError(error) {
  return {
    type: packageTrackerActions.SR_FAILURE,
    payload: error,
  };
}

export function shipRocketRecommendationThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${ThirdPartyService_URL}/callSrServiceabilityAPI?orderId=${props.orderId}&paymentType=${props.paymentType}`;
  return makeApiCall(
    getUrl,
    SRRecommendSuccess,
    SRRecommendError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}
